var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04034 10.1919C5.63244 10.261 5.22453 10.261 4.88461 10.3992C3.49094 10.8138 2.60715 12.2648 2.87908 13.7159C3.15102 15.2706 4.44272 16.2725 6.00635 16.1343C7.502 16.0306 8.72571 14.7869 8.72571 13.3013C8.7597 10.5719 8.7597 7.84258 8.7597 5.14777C8.7597 3.45488 8.7597 1.76199 8.7597 0C9.6095 0 10.4593 0 11.2751 0C11.3431 0 11.4451 0.138195 11.4451 0.207293C11.955 2.72935 13.4846 4.11131 15.932 4.49134C15.932 4.49134 15.966 4.49134 16 4.52589C16 5.52781 16 6.52972 16 7.63528C14.0964 7.73893 12.6008 7.0134 11.3771 5.38961C11.3771 5.666 11.3771 5.8042 11.3771 5.97694C11.3771 8.36081 11.3771 10.7447 11.3771 13.1631C11.3771 16.1688 9.2016 18.6218 6.31228 18.9673C3.42296 19.2782 0.771579 17.3435 0.12573 14.4068C-0.622094 10.8829 2.06327 7.42799 5.59844 7.42799C5.73441 7.42799 5.87038 7.46254 6.00635 7.46254C6.04034 8.39536 6.04034 9.32817 6.04034 10.1919Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTiktok);
export default __webpack_public_path__ + "static/media/icon_tiktok.cc48ca45a55fecd2409019b3f8ecdc00.svg";
export { ForwardRef as ReactComponent };